import { render } from "./SelectSources.vue?vue&type=template&id=452fffb4&scoped=true"
import script from "./SelectSources.vue?vue&type=script&lang=js"
export * from "./SelectSources.vue?vue&type=script&lang=js"

import "./SelectSources.vue?vue&type=style&index=0&id=452fffb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452fffb4"]])

export default __exports__